module.exports = __webpack_public_path__ + "images/confused.1b3cb69d0cc9cd3ad489.png";